var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.AddView-st0 {\r\n\t\t\tfill-rule: evenodd;\r\n\t\t\tclip-rule: evenodd;\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(42.666667, 85.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "AddView-st0",
    d: "M-22.1-71.6l0,3.4h3.4v2.3l-3.4,0l0,3.4h-2.3l0-3.4l-3.4,0v-2.3h3.4l0-3.4H-22.1z  M-31.2-84.2c8,0,11.4,9.1,11.4,9.1s-0.4,1-1.1,2.3l0,0l-2.7,0c0.6-0.9,1.1-1.7,1.4-2.3c-1-2-3.9-6.9-8.9-6.9c-5,0-8,4.9-8.9,6.9 c1,2,3.9,6.9,8.9,6.9c0.8,0,1.6-0.1,2.3-0.4l0,2.4c-0.7,0.2-1.5,0.3-2.3,0.3c-8,0-11.4-9.1-11.4-9.1S-39.2-84.2-31.2-84.2z  M-31.2-79c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S-33.4-79-31.2-79z M-31.2-76.8c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7 s1.7-0.8,1.7-1.7S-30.3-76.8-31.2-76.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddView);
export default __webpack_public_path__ + "static/media/AddView.e3b00fa1567b3b67b18aee733fff0bc6.svg";
export { ForwardRef as ReactComponent };